import { render } from "./propertiesScanDoc.vue?vue&type=template&id=0039bc97"
import script from "./propertiesScanDoc.vue?vue&type=script&lang=js"
export * from "./propertiesScanDoc.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__